<script>
    import PlayerDiv from './PlayerDiv.svelte';
    import PlayerModal from './PlayerModal.svelte';
    import NoProj from './NoProj.svelte';
    import { Navigation, Pagination, Scrollbar, A11y } from 'swiper';
	import { Swiper, SwiperSlide } from 'swiper/svelte/swiper-svelte.js';
	import GameCard from './GameCard.svelte';
    import 'swiper/swiper-bundle.min.css';
	// swiper core styles
	import 'swiper/swiper.min.css';
	// modules styles
	import 'swiper/modules/navigation/navigation.min.css';
	import 'swiper/modules/pagination/pagination.min.css';
    import { searchFilter, positionFilter, getTeams, filterByTeam, gameStrings } from './filter_utils.js';
    export let players = [];
    export let games = [];
    export let premium_membership = true;
    export let placeholder_variances = {};
    let mobile = window.innerWidth < 768;
    function checkMobile() {
		mobile = window.innerWidth < 768;
	}
	window.onresize = checkMobile;
    let playerSearchString = "";
    let selectedTeam = "all";
    let pos_filter = "all";
    let skater_goalie_select = "skaters";
    let teams = getTeams(games);
    let position_filters = ["C", "W", "D"];
    let teamGameStrings = gameStrings(games);
    // Skaters and goalies project different stats, so they get their own tables
    let skaters = players.filter(p => !p.positions.includes("G"));
    let goalies = players.filter(p => p.positions.includes("G"));
    let skaterCols = {name:0, toi:0, goals:0, assists:0, points:0, shots:0, blocked_shots:0, power_play_points:0, fp:0, dk_fp:0};
    let goalieCols = {name:0, wins:0, saves:0, shots_against:0, goals_against:0, shutouts:0, fp:0, dk_fp:0};
    let sortClasses = ["sort-asc", "", "sort-desc"];
    let modal_player;
    let modal_projection_id;
    function showPlayerModal(player) {
        modal_projection_id = player.stats.proj_id;
        modal_player = player;
        let myModal = new bootstrap.Modal(document.getElementById('player-modal'));
		myModal.show();
    }
    function sortByX(key, sortableCols, list, toggle=1){
		if(sortableCols[key] == 1){
			sortableCols[key] = -1 * toggle;
		}
		else{
			sortableCols[key] = 1 * toggle;
		}
        if(key != "name" && list.length && list[0].stats){
            list.sort((a, b) => (a.stats[key] > b.stats[key]) ? -1 * sortableCols[key]: 1 * sortableCols[key]);
        }
        else{
            list.sort((a, b) => (a[key] > b[key]) ? -1 * sortableCols[key]: 1 * sortableCols[key]);
        }
        for(var prop in sortableCols){
			if(prop != key){
				sortableCols[prop] = 0;
			}
		}
        return {players:list, sortableCols:sortableCols};
	}
    function sortSkaters(key) {
        let r = sortByX(key, skaterCols, skaters);
        skaters = r.players;
        skaterCols = r.sortableCols;
    }
    function sortGoalies(key) {
        let r = sortByX(key, goalieCols, goalies);
        goalies = r.players;
        goalieCols = r.sortableCols;
    }
    function pct(v) {
        return Math.round(v * 100) + "%";
    }
</script>
<style>
    .sorter{
		padding-right: 30px;
		position:relative;
	}
    .padding-r-30{
        padding-right: 30px;
    }
    .sticky-col {
        position: -webkit-sticky;
        position: sticky;
        left: 0px;
        background-color: #fff;
        z-index: 1;
    }
    .sticky-table-head{
        position: -webkit-sticky;
        position: sticky;
        top: 0px;
        background-color: #fff;
        z-index: 2;
    }
    .sticky-shadow-right{
        -webkit-box-shadow: inset -1px 0px 0px 0px #ccc;
        box-shadow: inset -1px 0px 0px 0px #ccc;
    }
    .sticky-shadow-bottom{
        -webkit-box-shadow: inset 0px -1px 0px 0px #ccc;
        box-shadow: inset 0px -1px 0px 0px #ccc;
    }
    .pointer{
		cursor:pointer;
	}
    .sorter.sort-asc:before{
		opacity: 1 !important;
	}
	.sorter.sort-desc:after{
		opacity: 1 !important;
	}
	.sorter:after,.sorter:before{
		position: absolute;
        bottom: 0em;
        display: block;
        opacity: .3;
		height:100%;
	}
	.sorter:after{
		right: .5em;
		content: "↓";
	}
	.sorter:before{
		right: 1em;
        content: "↑";
	}
</style>
{#if games.length > 0 && players.length > 0}
<PlayerModal placeholder_variances={placeholder_variances} league={'nhl'} player={modal_player} proj_id={modal_projection_id} premium_membership={premium_membership}></PlayerModal>
<div style="background-color:#e9ecef;" class="bg-gradient shadow border-top border-bottom py-2 mb-4">
	<h1 class="ps-2 display-6 lh-1">Games</h1>
	<Swiper
		modules={[Navigation, Pagination, Scrollbar, A11y]}
		spaceBetween={10}
		navigation="{!mobile}"
		pagination={{ clickable: true }}
		breakpoints={{
			320: { slidesPerView: 1, spaceBetween: 10 },
			768: { slidesPerView: 2, spaceBetween: 10 },
			1024: { slidesPerView: 3, spaceBetween: 10 },
			1280: { slidesPerView: 4, spaceBetween: 10 },
			1920: { slidesPerView: 5, spaceBetween: 10 }
		}}
	>
		{#each games as game}
		<SwiperSlide><GameCard home_team={game.home_team} away_team={game.away_team} game_time={game.game_time} lines={game.lines}></GameCard></SwiperSlide>
		{/each}
	</Swiper>
</div>
<div class="container-fluid">
    <div class="row">
        <div class="col-12">
            <div class="d-flex h-100 align-items-center btn-group" role="group" aria-label="Skaters or goalies">
                <input type="radio" bind:group={skater_goalie_select} value="skaters" class="btn-check" name="btnradio" id="btnradio1" autocomplete="off" checked>
                <label class="w-100 btn btn-outline-primary" for="btnradio1">Skaters</label>
                <input type="radio" bind:group={skater_goalie_select} value="goalies" class="btn-check" name="btnradio" id="btnradio2" autocomplete="off">
                <label class="w-100 btn btn-outline-primary" for="btnradio2">Goalies</label>
            </div>
        </div>
        <div class="{skater_goalie_select === 'skaters' ? 'col-lg-4' : 'col-md-6'} pb-1 mt-auto">
            <label for="team-select">Filter By Team</label>
            <select bind:value={selectedTeam} class="form-select form-select-lg" id="team-select">
                <option value="all">All</option>
                {#each teams as team}
                    <option value="{team.short_name}">{team.city_name} {team.mascot_name}</option>
                {/each}
            </select>
        </div>
        <div class="{skater_goalie_select === 'skaters' ? 'col-lg-4' : 'd-none'} pb-1 mt-auto">
            <div class="d-flex h-100 align-items-center btn-group" role="group" aria-label="Position filter">
                <input type="radio" bind:group={pos_filter} value="all" class="btn-check" name="pos-radio" id="posradio1" autocomplete="off" checked>
                <label class="w-100 btn btn-outline-primary" for="posradio1">All</label>
                {#each position_filters as position, index}
                <input type="radio" bind:group={pos_filter} class="btn-check" name="pos-radio" id="posradio{index+2}" value="{position}" autocomplete="off">
                <label class="w-100 btn btn-outline-primary" for="posradio{index+2}">{position}</label>
                {/each}
            </div>
        </div>
        <div class="{skater_goalie_select === 'skaters' ? 'col-lg-4' : 'col-md-6'} pb-1 mt-auto">
            <div class="input-group input-group-lg">
                <span class="input-group-text" id="inputGroup-sizing-lg">🔍</span>
                <input bind:value={playerSearchString} autocomplete="off" id="player-search" type="text" class="form-control" aria-label="Search for a player" placeholder="Search for a Player..." aria-describedby="inputGroup-sizing-lg">
            </div>
        </div>
    </div>
    {#if skater_goalie_select == "skaters"}
    <div class="table-responsive modern-card bg-light m-2 pb-2" style="max-height: 75vh;">
        <table class="table">
            <thead class="sticky-table-head sticky-shadow-bottom pt-2">
                <tr class="ps-2">
                    <th on:click={()=>sortSkaters("name")} class="sticky-col sticky-shadow-right {sortClasses[skaterCols["name"]+1]} padding-r-30 sorter pointer">Name</th>
                    <th class="{sortClasses[skaterCols["toi"]+1]} padding-r-30 text-center sorter pointer" on:click={()=>sortSkaters("toi")}>TOI</th>
                    <th class="{sortClasses[skaterCols["goals"]+1]} padding-r-30 text-center sorter pointer" on:click={()=>sortSkaters("goals")}>Goals</th>
                    <th class="{sortClasses[skaterCols["assists"]+1]} padding-r-30 text-center sorter pointer" on:click={()=>sortSkaters("assists")}>Assists</th>
                    <th class="{sortClasses[skaterCols["points"]+1]} padding-r-30 text-center sorter pointer border-end" on:click={()=>sortSkaters("points")}>Points</th>
                    <th class="{sortClasses[skaterCols["shots"]+1]} padding-r-30 text-center sorter pointer" on:click={()=>sortSkaters("shots")}>SOG</th>
                    <th class="{sortClasses[skaterCols["blocked_shots"]+1]} padding-r-30 text-center sorter pointer" on:click={()=>sortSkaters("blocked_shots")}>Blocks</th>
                    <th class="{sortClasses[skaterCols["power_play_points"]+1]} padding-r-30 text-center sorter pointer border-end" on:click={()=>sortSkaters("power_play_points")}>PP Pts</th>
                    <th class="{sortClasses[skaterCols["fp"]+1]} padding-r-30 sorter text-center pointer" on:click={()=>sortSkaters("fp")}>FD FP</th>
                    <th class="{sortClasses[skaterCols["dk_fp"]+1]} padding-r-30 sorter text-center pointer" on:click={()=>sortSkaters("dk_fp")}>DK FP</th>
                </tr>
            </thead>
            <tbody class="border-top-0">
                {#each skaters as ps}
                {#if positionFilter(ps, pos_filter) && searchFilter(ps, playerSearchString) && filterByTeam(ps.team, selectedTeam)}
                <tr class="ps-2">
                    <td class="pointer sticky-col sticky-shadow-right pb-0" on:click={()=>{showPlayerModal(ps)}}>
                        <PlayerDiv player_image={ps.img_thumb} player_positions={ps.positions} player_name={ps.name} detail_string={teamGameStrings[ps.team]} player_inj_tag={ps.injury_tag}/>
                    </td>
                    <td class="align-bottom padding-r-30 text-center">{ps.stats.toi.toFixed(1)}</td>
                    <td class="align-bottom padding-r-30 text-center">{ps.stats.goals}</td>
                    <td class="align-bottom padding-r-30 text-center">{ps.stats.assists}</td>
                    <td class="align-bottom padding-r-30 text-center border-end">{ps.stats.points}</td>
                    <td class="align-bottom padding-r-30 text-center">{ps.stats.shots}</td>
                    <td class="align-bottom padding-r-30 text-center">{ps.stats.blocked_shots}</td>
                    <td class="align-bottom padding-r-30 text-center border-end">{ps.stats.power_play_points}</td>
                    <td class="align-bottom padding-r-30 text-center">{ps.stats.fp}</td>
                    <td class="align-bottom padding-r-30 text-center">{ps.stats.dk_fp}</td>
                </tr>
                {/if}
                {/each}
            </tbody>
        </table>
    </div>
    {:else}
    <div class="table-responsive modern-card bg-light m-2 pb-2" style="max-height: 75vh;">
        <table class="table">
            <thead class="sticky-table-head sticky-shadow-bottom pt-2">
                <tr class="ps-2">
                    <th on:click={()=>sortGoalies("name")} class="sticky-col sticky-shadow-right {sortClasses[goalieCols["name"]+1]} padding-r-30 sorter pointer">Name</th>
                    <th class="{sortClasses[goalieCols["wins"]+1]} padding-r-30 text-center sorter pointer" on:click={()=>sortGoalies("wins")}>Win %</th>
                    <th class="{sortClasses[goalieCols["saves"]+1]} padding-r-30 text-center sorter pointer" on:click={()=>sortGoalies("saves")}>Saves</th>
                    <th class="{sortClasses[goalieCols["shots_against"]+1]} padding-r-30 text-center sorter pointer" on:click={()=>sortGoalies("shots_against")}>Shots Against</th>
                    <th class="{sortClasses[goalieCols["goals_against"]+1]} padding-r-30 text-center sorter pointer" on:click={()=>sortGoalies("goals_against")}>Goals Against</th>
                    <th class="{sortClasses[goalieCols["shutouts"]+1]} padding-r-30 text-center sorter pointer border-end" on:click={()=>sortGoalies("shutouts")}>Shutout %</th>
                    <th class="{sortClasses[goalieCols["fp"]+1]} padding-r-30 sorter text-center pointer" on:click={()=>sortGoalies("fp")}>FD FP</th>
                    <th class="{sortClasses[goalieCols["dk_fp"]+1]} padding-r-30 sorter text-center pointer" on:click={()=>sortGoalies("dk_fp")}>DK FP</th>
                </tr>
            </thead>
            <tbody class="border-top-0">
                {#each goalies as ps}
                {#if searchFilter(ps, playerSearchString) && filterByTeam(ps.team, selectedTeam)}
                <tr class="ps-2">
                    <td class="pointer sticky-col sticky-shadow-right pb-0" on:click={()=>{showPlayerModal(ps)}}>
                        <PlayerDiv player_image={ps.img_thumb} player_positions={ps.positions} player_name={ps.name} detail_string={teamGameStrings[ps.team]} player_inj_tag={ps.injury_tag}/>
                    </td>
                    <td class="align-bottom padding-r-30 text-center">{pct(ps.stats.wins)}</td>
                    <td class="align-bottom padding-r-30 text-center">{ps.stats.saves}</td>
                    <td class="align-bottom padding-r-30 text-center">{ps.stats.shots_against}</td>
                    <td class="align-bottom padding-r-30 text-center">{ps.stats.goals_against}</td>
                    <td class="align-bottom padding-r-30 text-center border-end">{pct(ps.stats.shutouts)}</td>
                    <td class="align-bottom padding-r-30 text-center">{ps.stats.fp}</td>
                    <td class="align-bottom padding-r-30 text-center">{ps.stats.dk_fp}</td>
                </tr>
                {/if}
                {/each}
            </tbody>
        </table>
    </div>
    {/if}
</div>
{:else}
<NoProj league={"NHL"} logo_url={window.logo_url}></NoProj>
{/if}
